import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToHash = (offset = 120) => {
  const location = useLocation();

  useEffect(() => {
    // Only execute if there's a hash in the URL
    if (location.hash) {
      // Small delay to ensure the DOM is fully rendered
      setTimeout(() => {
        const id = location.hash.replace('#', '');
        const element = document.getElementById(id);
        
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // If no hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [location, offset]);
};

export default useScrollToHash;
